import "@/css/Dashboard/index.css";
import { get } from "@/js/request.js";
import {
  createNewsBox,
  createShortSwiperItem,
} from "@/js/ComponentJs/ShortImageContainer";

function getNews(successCallBack) {
  get(
    "/journalism/news-list",
    { page: 1, pageSize: 3, isDashboard: 1 },
    successCallBack
  );
}

//静态数据
let dataList = {
  hoverBoxItemData: [
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
      brandIcon: require("@/assets/image/brandIcon1.png"),
    },
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
      brandIcon: require("@/assets/image/brandIcon2.png"),
    },
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
      brandIcon: require("@/assets/image/brandIcon3.png"),
    },
    {
      imageUrl: require("@/assets/image/brand-bg.png"),
      brandIcon: require("@/assets/image/brandIcon4.png"),
    },
  ],
  productSwiperList: [
    {
      imageUrl: require("@/assets/image/product_001.png"),
    },
    {
      imageUrl: require("@/assets/image/product_002.png"),
    },
    {
      imageUrl: require("@/assets/image/product_003.png"),
    },
    {
      imageUrl: require("@/assets/image/product_004.png"),
    },
    {
      imageUrl: require("@/assets/image/product_005.png"),
    },
  ],
  brandSwiperList: [
    {
      imageUrl: require("@/assets/image/brand_1.png"),
    },
    {
      imageUrl: require("@/assets/image/brand_2.png"),
    },
    {
      imageUrl: require("@/assets/image/brand_3.png"),
    },
    {
      imageUrl: require("@/assets/image/brand_4.png"),
    },
    {
      imageUrl: require("@/assets/image/brand_5.png"),
    },
  ],
  storeSwiperList: [
    {
      imageUrl: require("@/assets/image/store_1.png"),
    },
    {
      imageUrl: require("@/assets/image/store_2.png"),
    },
    {
      imageUrl: require("@/assets/image/store_3.png"),
    },
    {
      imageUrl: require("@/assets/image/store_4.png"),
    },
  ],
  ecologyIcon: [
    {
      imageUrl: require("@/assets/image/ecology_1.jpg"),
      activeImageUrl: require("@/assets/image/ecology_1_active.jpg"),
    },
    {
      imageUrl: require("@/assets/image/ecology_2.jpg"),
      activeImageUrl: require("@/assets/image/ecology_2_active.jpg"),
    },
    {
      imageUrl: require("@/assets/image/ecology_3.jpg"),
      activeImageUrl: require("@/assets/image/ecology_3_active.jpg"),
    },
  ],
};

//视频
document.querySelector(".video").loop = true;
document.querySelector(".video").play();
//大健康全产业垂直生态链
let ecologyIcon = dataList.ecologyIcon;
let ecologyIconImg = Array.from(
  document.querySelectorAll(".ecology_icon .active_img")
);
let ecologyIconImgh = Array.from(
  document.querySelectorAll(".ecology_icon .active_imgh")
);
ecologyIconImg.forEach((item, idx) => {
  item.src = ecologyIcon[idx].imageUrl;
});
ecologyIconImgh.forEach((item, idx) => {
  item.src = ecologyIcon[idx].activeImageUrl;
});
document.querySelectorAll(".Management_Down img").forEach((item, idx) => {
  item.src = require("@/assets/image/ecology.png");
});
//商品盒子
let heightBoxList = dataList.productSwiperList;
let heightBoxContainer = Array.from(
  document.querySelectorAll(".heightImageList .imageContainer img")
);
let heightBoxSwiperImg = Array.from(
  document.querySelectorAll(".heightImageSwiper .imageContainer img")
);
heightBoxContainer.forEach((item, idx) => {
  item.src = heightBoxList[idx].imageUrl;
});
heightBoxSwiperImg.forEach((item, idx) => {
  item.src = heightBoxList[idx].imageUrl;
});
//品牌故事盒子
let BoxItemList = dataList.hoverBoxItemData;
let hoverBoxContainer = Array.from(
  document.querySelectorAll(".hoverBoxContainer .boxContainer .icon")
);
let hoverSwiperWrapper = Array.from(
  document.querySelectorAll(".hover-swiper .hoverBox img")
);
hoverBoxContainer.forEach(
  (item, idx) => (item.src = BoxItemList[idx].brandIcon)
);
hoverSwiperWrapper.forEach(
  (item, idx) => (item.src = BoxItemList[idx].imageUrl)
);
//新闻盒子

let shortBoxContainer = document.querySelector(".shortBoxList");
let shortBoxSwiperImg = document.querySelector(".short-swiper");
getNews((res) => {
  createNewsBox(res.data?.list, shortBoxContainer);
  createShortSwiperItem(res.data?.list, shortBoxSwiperImg);
  let shortBoxSwiper = new Swiper(".short-swiper", {
    loop: true,
    effect: "fade",
    autoplay: 3000,
    autoplayDisableOnInteraction: false,
  });
});
//旗下品牌盒子

let brandSwiperList = dataList.brandSwiperList;

let brandSwiperWrapper = Array.from(
  document.querySelectorAll(".brandSwiper .swiper-wrapper img")
);
brandSwiperWrapper.forEach(
  (item, idx) => (item.src = brandSwiperList[idx].imageUrl)
);
// 门店
let storeSwiperList = dataList.storeSwiperList;

let storeSwiperWrapper = Array.from(
  document.querySelectorAll(".store-swiper .swiper-wrapper img")
);
storeSwiperWrapper.forEach(
  (item, idx) => (item.src = storeSwiperList[idx].imageUrl)
);
document.querySelectorAll(
  ".phoneImg  img"
)[0].src = require("@/assets/image/wechatPhone.png");
document.querySelectorAll(
  ".code  img"
)[0].src = require("@/assets/image/miniProgramEwm.jpg");
let storeSwiper = new Swiper(".store-swiper", {
  autoplay: 3000,
  speed: 1000,
  autoplayDisableOnInteraction: false,
  loop: true,
  centeredSlides: true,
  slidesPerView: 3,
  pagination: ".swiper-pagination",
  paginationClickable: true,
  prevButton: ".swiper-button-prev",
  nextButton: ".swiper-button-next",
  onInit: function (swiper) {
    // swiper.slides[2].className = "swiper-slide swiper-slide-active"; //第一次打开不要动画
  },
  breakpoints: {
    668: {
      slidesPerView: 1,
    },
  },
});
//屏幕为小尺寸时的轮播轮播
let heightBoxSwiper = new Swiper(".swiper", {
  loop: true, // 循环模式选项
});
let hoverBoxSwiper = new Swiper(".hover-swiper", {
  loop: true,
  effect: "fade",
});

let brandSwiper = new Swiper(".brandSwiper", {
  loop: true,
  autoplay: 3000,

  // 如果需要分页器
  pagination: ".swiper-pagination",

  // 如果需要前进后退按钮
  nextButton: ".swiper-button-next",
  prevButton: ".swiper-button-prev",
});

document.querySelector(
  ".leader-footer-img"
).src = require("@/assets/image/leader.png");
document.querySelector(
  ".leader-content-img"
).src = require("@/assets/image/certificate.jpg");

document.getElementById("loading").classList.remove("active");
